export const FETCH_CONTENT_LIST_REQUEST = 'FETCH_CONTENT_LIST_REQUEST';
export const FETCH_CONTENT_LIST_SUCCESS = 'FETCH_CONTENT_LIST_REQUEST';
export const FETCH_CONTENT_LIST_FAILED = 'FETCH_CONTENT_LIST_REQUEST';

export const FETCH_PAGE_LIST_REQUEST = 'FETCH_PAGE_LIST_REQUEST';
export const FETCH_PAGE_LIST_SUCCESS = 'FETCH_PAGE_LIST_SUCCESS';
export const FETCH_PAGE_LIST_FAILED = 'FETCH_PAGE_LIST_FAILED';

export const SELECT_CONTENT_LIST_EDIT = 'SELECT_CONTENT_LIST_EDIT';

export const UPDATE_CONTENT_REQUEST = 'UPDATE_CONTENT_REQUEST';
export const UPDATE_CONTENT_SUCCESS = 'UPDATE_CONTENT_SUCCESS';
export const UPDATE_CONTENT_FAILED = 'UPDATE_CONTENT_FAILED';

export const INSERT_CONTENT_REQUEST = 'INSERT_CONTENT_REQUEST';
export const INSERT_CONTENT_SUCCESS = 'INSERT_CONTENT_SUCCESS';
export const INSERT_CONTENT_FAILED = 'INSERT_CONTENT_FAILED';

export const DELETE_CONTENT_REQUEST = 'DELETE_CONTENT_REQUEST';
export const DELETE_CONTENT_SUCCESS = 'DELETE_CONTENT_SUCCESS';
export const DELETE_CONTENT_FAILED = 'DELETE_CONTENT_FAILED';

export const FETCH_IMAGE_LIST_REQUEST = 'FETCH_IMAGE_LIST_REQUEST';
export const FETCH_IMAGE_LIST_SUCCESS = 'FETCH_IMAGE_LIST_SUCCESS';
export const FETCH_IMAGE_LIST_FAILED = 'FETCH_IMAGE_LIST_FAILED';

export const UPLOAD_IMAGE_REQUEST = 'UPLOAD_IMAGE_REQUEST';
export const UPLOAD_IMAGE_SUCCESS = 'UPLOAD_IMAGE_SUCCESS';
export const UPLOAD_IMAGE_FAILED = 'UPLOAD_IMAGE_FAILED';

export const FETCH_TEMPLATE_REQUEST = 'FETCH_TEMPLATE_REQUEST';
export const FETCH_TEMPLATE_SUCCESS = 'FETCH_TEMPLATE_SUCCESS';
export const FETCH_TEMPLATE_FAILED = 'FETCH_TEMPLATE_FAILED';